"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../../conf/index");
const __sfc_main = {};
__sfc_main.props = {
    data: {
        type: Object,
        required: true
    },
    appType: {
        type: String,
        required: true
    }
};
__sfc_main.setup = (__props, __ctx) => {
    var _a;
    const { ftReport } = ((_a = window.FEGORender) === null || _a === void 0 ? void 0 : _a.plugins) || {};
    const props = __props;
    const stopPropagation = e => {
        e.stopPropagation();
        e.preventDefault();
    };
    const toStock = evt => {
        stopPropagation(evt);
        const stockId = props.data.stockId;
        if (!stockId) {
            return;
        }
        ftReport.record(evt, {
            $element_name: `点击股票${props.data.stockId}`
        });
        let target = '';
        if (props.appType === index_1.APP_TYPE_MAP.NN) {
            target = `futunn://quote/stockDetail/${props.data.stockId}/1`;
        }
        else {
            target = `futumm://quote/stockDetail/${props.data.stockId}/1`;
        }
        window.location.href = target;
    };
    const emit = __ctx.emit;
    const subscribeStock = evt => {
        stopPropagation(evt);
        emit('subscribe');
    };
    const unsubscribeStock = evt => {
        stopPropagation(evt);
        emit('unsubscribe');
    };
    return {
        toStock,
        subscribeStock,
        unsubscribeStock
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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